import { Outlet, useLocation } from 'react-router-dom';
import { FALLBACK_HOME, useHomeContent } from '../lib/content';
import { SiteHeader } from './layout/SiteHeader';
import { SiteFooter } from './layout/SiteFooter';
import { CookieBanner } from './CookieBanner';

export function Layout() {
  const { pathname } = useLocation();
  const { data } = useHomeContent();
  const settings = data?.settings ?? FALLBACK_HOME.settings;
  const isHome = pathname === '/';
  const isWide = pathname.startsWith('/chat') || pathname.startsWith('/tariffs') || pathname.startsWith('/cases');

  return (
    <div className="relative flex min-h-full flex-col overflow-x-clip">

      <SiteHeader settings={settings} />
      <main
        className={[
          'min-w-0 flex-1',
          isHome
            ? ''
            : isWide
              ? 'px-4 py-6 md:px-8'
              : 'mx-auto w-full max-w-5xl px-4 py-8 md:px-6',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <Outlet />
      </main>
      <SiteFooter settings={settings} />
      <CookieBanner />
    </div>
  );
}
